import { axiosInstance } from '../../utils';
import { ScrapedData } from '../../@types';

interface Payload {
  url: string;
}

export const getDraftContentStatus = async (payload: Payload): Promise<ScrapedData> => {
  const res = await axiosInstance.post('/api/scrape-url/get-entry', payload);
  return res.data;
};
